// Shared message keys for the single claim/conversion rule editor.
const messages: Record<string, [string, string, string, string]> = {
  description: [
    '统一维护当前园区线索、客户的领取与超期释放规则，以及线索自动转商机的意向率阈值。保存后生效。',
    'Manage claim limits and automatic release rules for this park’s leads and customers, and the threshold for automatic lead conversion. Changes take effect after saving.',
    '統一維護目前園區線索、客戶的領取與逾期釋放規則，以及線索自動轉商機的意向率閾值。儲存後生效。',
    '現在の園区のリード・顧客の取得上限、自動解放ルール、リードの商談化基準を設定します。保存後に反映されます。',
  ],
  conversion: ['线索转化', 'Lead Conversion', '線索轉化', 'リードの商談化'],
  threshold: [
    '线索自动转商机的意向率阈值（%）',
    'Intent threshold for automatic conversion (%)',
    '線索自動轉商機的意向率閾值（%）',
    '商談化する意向率の基準（%）',
  ],
  thresholdPlaceholder: [
    '尚未配置，请填写 0–100',
    'Not configured; enter 0–100',
    '尚未設定，請填寫 0–100',
    '未設定です。0～100を入力',
  ],
  thresholdHelp: [
    '意向率需超过阈值且资料齐全，保存线索后自动转为商机；未配置时不会自动转化。',
    'Saving a complete lead with intent above this threshold automatically converts it to an opportunity. Conversion is disabled while the threshold is unconfigured.',
    '意向率需超過閾值且資料齊全，儲存線索後自動轉為商機；未設定時不會自動轉化。',
    '情報が揃い、意向率が基準を超えるリードは、保存時に自動で商談化されます。基準が未設定の場合は自動変換されません。',
  ],
  thresholdRequired: [
    '请设置转化阈值',
    'Enter a conversion threshold',
    '請設定轉化閾值',
    '商談化の基準を入力してください',
  ],
  claim: [
    '领取与超期释放',
    'Claims and Automatic Release',
    '領取與逾期釋放',
    '取得と期限超過時の解放',
  ],
  claimLimit: [
    '每人每日领取上限',
    'Daily claim limit per person',
    '每人每日領取上限',
    '1人あたりの1日の取得上限',
  ],
  claimPlaceholder: [
    '请输入领取上限',
    'Enter a claim limit',
    '請輸入領取上限',
    '取得上限を入力',
  ],
  claimHelp: [
    '0 表示不限制；线索与客户分别计算每日领取数量。',
    '0 means unlimited. Leads and customers have separate daily counts.',
    '0 表示不限制；線索與客戶分別計算每日領取數量。',
    '0は無制限です。リードと顧客は別々に集計されます。',
  ],
  claimRequired: [
    '请填写上限',
    'Enter a daily limit',
    '請填寫上限',
    '上限を入力してください',
  ],
  autoRelease: [
    '启用超期自动释放',
    'Enable automatic release',
    '啟用逾期自動釋放',
    '期限超過時の自動解放',
  ],
  enabled: ['启用', 'Enabled', '啟用', '有効'],
  disabled: ['关闭', 'Disabled', '關閉', '無効'],
  releaseDays: [
    '超期未跟进天数',
    'Days without follow-up',
    '逾期未跟進天數',
    '未フォローの日数',
  ],
  daysPlaceholder: [
    '请输入 1–365 天',
    'Enter 1–365 days',
    '請輸入 1–365 天',
    '1～365日を入力',
  ],
  releaseHelp: [
    '启用后，超过设定天数未跟进的线索、客户将自动释放到待领取范围。',
    'When enabled, leads and customers without follow-up for the specified period return to the claim pool.',
    '啟用後，超過設定天數未跟進的線索、客戶將自動釋放到待領取範圍。',
    '有効にすると、指定日数を超えてフォローされていないリード・顧客が未割当の状態に戻ります。',
  ],
  daysRequired: [
    '请填写天数',
    'Enter a number of days',
    '請填寫天數',
    '日数を入力してください',
  ],
  save: ['保存规则', 'Save Rules', '儲存規則', 'ルールを保存'],
  reset: ['撤销更改', 'Discard Changes', '撤銷變更', '変更を取り消す'],
  saved: [
    '领取与转化规则已保存',
    'Claim and conversion rules saved',
    '領取與轉化規則已儲存',
    '取得・商談化ルールを保存しました',
  ],
  loadFailed: [
    '规则加载失败，请重试',
    'Unable to load rules. Please retry.',
    '規則載入失敗，請重試',
    'ルールを読み込めませんでした。再試行してください。',
  ],
  saveFailed: [
    '规则保存失败，请重试',
    'Unable to save rules. Please retry.',
    '規則儲存失敗，請重試',
    'ルールを保存できませんでした。再試行してください。',
  ],
  retry: ['重新加载', 'Reload', '重新載入', '再読み込み'],
  unsaved: [
    '规则尚未保存，是否放弃更改？',
    'Discard unsaved rule changes?',
    '規則尚未儲存，是否放棄變更？',
    '未保存のルール変更を破棄しますか？',
  ],
  discard: ['放弃更改', 'Discard Changes', '放棄變更', '変更を破棄'],
  continue: ['继续编辑', 'Continue Editing', '繼續編輯', '編集を続ける'],
};

export const attractionRuleMessages = (locale: 0 | 1 | 2 | 3) =>
  Object.fromEntries(
    Object.entries(messages).map(([key, values]) => [
      `pages.attractionRule.${key}`,
      values[locale],
    ]),
  );
